import React from "react";

export default function MatchCompletionReview({ matchName, pendingChecks, pendingEntries, sideMatches = [], busy, disabled, onCancel, onConfirm }) {
  return <section className="dp-notice dp-completion-review" role="group" aria-label="Review match completion">
    <h3>Has shooting finished?</h3>
    <p>Mark <strong>{matchName}</strong> completed and move it to past matches. Self-registration will close. Scores remain editable and are not finalized by this action.</p>
    {sideMatches.length > 0 && <><p>This also completes {sideMatches.length} side {sideMatches.length === 1 ? "match" : "matches"}. Review their score uploads separately; the checks on this page cover only the selected match.</p><ul>{sideMatches.map(side => <li key={side.matchId}>{side.matchName}</li>)}</ul></>}
    {pendingChecks > 0 && <p>{pendingChecks} score checks still need review. Completion will not resolve them.</p>}
    {pendingEntries > 0 && <p>{pendingEntries} registrations are still pending.</p>}
    <p>You can return the match to In progress in Match status & settings.</p>
    <div className="dp-actions">
      <button type="button" className="dp-button" autoFocus disabled={busy} onClick={onCancel}>Keep match open</button>
      <button type="button" className="dp-button dp-primary" disabled={busy || disabled} onClick={onConfirm}>{busy ? "Saving…" : "Confirm match completed"}</button>
    </div>
  </section>;
}
